<div class="c-portlet o-block u-width-100p _u-width-100p u-bg-primarys pos-relative {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
	>
		<div>
			<h5>Networks & Programs</h5>
			<a
				href="#"
				class="networks_download_icon"
				*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
				(click)="downloadDataInCSV($event)"
				target="_blank"
			>
				<i *ngIf="!downloadIcon" class="fa fa-download" aria-hidden="true"></i>
				<img *ngIf="downloadIcon" class="downloadIcon" src="{{ downloadIcon }}" />
			</a>
		</div>
	</div>
	<div class="c-portlet__content u-pt-small r101_widget_div" style="width: 100%; position: relative">
		<div
			class="o-stack__cell arrow_cell"
			style="position: absolute; width: 100%; height: 100%; z-index: 1001"
			*ngIf="totalCreatives > 1 && hasData"
		>
			<div class="o-stack o-stack--center o-stack--nowrap" style="width: 100%; height: 100%; position: relative">
				<div class="o-stack__cell u-relative" style="width: 100%; height: 100%">
					<a class="u-opacity-50p leftRs_tv">
						<span class="next" (click)="nextArrow()" class="carousel-arrow-style">
							<i *ngIf="!isR103" style="font-size: 5rem" class="fa fa-angle-left" aria-hidden="true"></i>
							<i *ngIf="isR103">
								<svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="chevron-up-solid 4" clip-path="url(#clip0_4896_525)">
										<path
											id="Vector"
											d="M7.41089 13.9362C6.53198 14.8011 6.53198 16.2058 7.41089 17.0708L20.9109 30.3565C21.7898 31.2214 23.2171 31.2214 24.096 30.3565C24.975 29.4915 24.975 28.0868 24.096 27.2219L12.1851 15.5L24.089 3.77813C24.9679 2.91317 24.9679 1.50848 24.089 0.643529C23.2101 -0.221427 21.7828 -0.221427 20.9039 0.643529L7.40386 13.9292L7.41089 13.9362Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4896_525">
											<rect width="31" height="36" fill="white" transform="matrix(0 1 1 0 0 0)" />
										</clipPath>
									</defs>
								</svg>
							</i> </span
					></a>
					<a class="u-opacity-50p rightRs_tv">
						<span class="prev" (click)="prevArrow()" class="carousel-arrow-style">
							<i *ngIf="!isR103" style="font-size: 5rem" class="fa fa-angle-right" aria-hidden="true"></i>
							<i *ngIf="isR103">
								<svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="chevron-up-solid 5" clip-path="url(#clip0_4896_523)">
										<path
											id="Vector"
											d="M28.5891 17.0638C29.468 16.1989 29.468 14.7942 28.5891 13.9292L15.0891 0.643522C14.2102 -0.221434 12.7829 -0.221434 11.904 0.643522C11.025 1.50848 11.025 2.91317 11.904 3.77812L23.8149 15.5L11.911 27.2219C11.0321 28.0868 11.0321 29.4915 11.911 30.3565C12.7899 31.2214 14.2172 31.2214 15.0961 30.3565L28.5961 17.0708L28.5891 17.0638Z"
											fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4896_523">
											<rect
												width="31"
												height="36"
												fill="white"
												transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 36 31)"
											/>
										</clipPath>
									</defs>
								</svg>
							</i>
						</span>
					</a>
				</div>
			</div>
		</div>
		<div class="analytics-portlet-content network-program-content" style="width: 100%" *ngIf="hasData">
			<div *ngIf="networkDetail">
				<div class="flex-container-ntwk">
					<div style="height: 380px" class="network_container">
						<div class="network_img">
							<img [src]="networkDetail?.thumbnail" *ngIf="networkDetail?.thumbnail" class="network_image" />
							<div class="tv_marphedlogo" *ngIf="!networkDetail?.thumbnail" id="tvNnPLogo" style="font-size: 130px">
								{{ networkDetail?.marphedlogo }}
							</div>
						</div>
						<div class="network_name">{{ networkDetail?.networkName }}</div>
					</div>
					<div class="network_table">
						<ngx-datatable
							#table
							style="height: 100%"
							class="datatable ngx-datatable tv_daypart_table"
							[columns]="columns"
							[rows]="programs"
							[sortType]="'single'"
							[columnMode]="'force'"
							[footerHeight]="50"
							[headerHeight]="50"
							[limit]="tableLimit"
							[scrollbarV]="false"
						>
							<ng-template ngFor let-column [ngForOf]="columns">
								<ngx-datatable-column
									name="{{ column.name }}"
									prop="{{ column.prop }}"
									[resizeable]="false"
									[sortable]="true"
									[cellClass]="column.className"
									[headerClass]="column.className"
								>
									<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
										<span (click)="sort()" class="cursor-pointer">
											{{ colHeader.name }}
										</span>
									</ng-template>
								</ngx-datatable-column>
							</ng-template>
						</ngx-datatable>
					</div>
				</div>
				<div class="footer-note">
					<p style="display: inline-block">Dashboard reporting may not reflect comprehensive lists of placements.</p>
					<p style="display: inline-block">Known variances include campaigns with:15 bookend placements.</p>
					<p style="display: inline-block">
						Please continue to reference Midco invoices and affidavits for complete campaign information.
					</p>
				</div>
			</div>
		</div>
		<div *ngIf="!hasData" class="no-data-container">
			<div class="no_data_container">No Data to Display</div>
		</div>
	</div>
</div>
